<template>
  <div class="shiyong_out">
    <div v-if="!pupopShow">
      <div class="headerSearch">
        <div class="sousuo">
          <el-form
            ref="search"
            style="display: flex"
            :model="searchForm"
            label-position="left"
            label-width="90px"
          >
            <el-form-item label="化学品:" style="">
              <el-input
                v-model="searchForm.param.hxpMc"
                placeholder="请输入"
              />
            </el-form-item>
            <el-form-item label="仓库名称:">
              <el-select
                v-model="searchForm.param.ckId"
                filterable
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="(item, index) in ckmcList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="领用日期:">
              <el-col :span="10">
                <el-date-picker
                  v-model="searchForm.param.beginLyrq"
                  type="date"
                  style="width: 100%"
                  placeholder="选择日期"
                  :picker-options="startTime"
                />
              </el-col>
              <el-col
                style="text-align: center"
                class="line"
                :span="3"
              >-</el-col>
              <el-col :span="10">
                <el-date-picker
                  v-model="searchForm.param.endLyrq"
                  type="date"
                  style="width: 100%"
                  placeholder="选择日期"
                  :picker-options="endTime"
                />
              </el-col>
            </el-form-item>
            <el-form-item label="状态:" label-width="50px">
              <el-select
                v-model="searchForm.param.zt"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="(item, index) in statusList"
                  :label="item.label"
                  :value="item.value"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-button
              v-preventReClick
              class="sousuoButton"
              icon="el-icon-search"
              round
              size="small"
              type="primary"
              @click="handleCurrentChange(1)"
            >搜索</el-button>
            <el-button
              v-preventReClick
              class="resetbutton"
              size="small"
              icon="el-icon-refresh-right"
              @click="reset"
            >重置</el-button>
          </el-form>
        </div>
      </div>
      <div
        style="
          margin: auto;
          width: 95%;
          max-width: 1518px;
          background-color: white;
          padding-top: 40px;
          padding-bottom: 57px;
        "
      >
        <div class="tablemes">
          <el-table
            ref="cktable"
            :data="tableData"
            border
            :cell-style="cellStyle"
            :show-overflow-tooltip="true"
            :header-cell-style="{ background: '#F2F2F2' }"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column>
              <template slot="header">
                <el-button
                  v-preventReClick
                  type="primary"
                  class="addButton"
                  size="mini"
                  style="border: none"
                  icon="el-icon-plus"
                  @click="addPupShow('add', '0')"
                >新增</el-button>
                <el-button
                  v-preventReClick
                  size="mini"
                  icon="el-icon-plus"
                  @click="addByCopy"
                >复制新增</el-button>
                <el-button
                  v-preventReClick
                  icon="el-icon-upload2"
                  size="mini"
                  @click="exportExcel"
                >导出</el-button>
              </template>
              <el-table-column
                align="center"
                type="selection"
                width="55"
              />

              <el-table-column
                v-for="(item, i) in table"
                :key="i"
                :show-overflow-tooltip="true"
                align="center"
                :label="item.label"
                :prop="
                  item.key == 'lyrq' || item.key == 'djsj' ? item.props : ''
                "
                :width="item.key == 'ckbh' ? '180' : ''"
              >
                <template slot-scope="scope">
                  <span
                    v-if="item.key != 'bgcs' || scope.row[item.key] == 0"
                    :title="scope.row[item.key]"
                  >
                    {{
                      item.key == "cksl" && scope.row["ckslDwLabel"] != null
                        ? scope.row[item.key] +
                          "  (" +
                          scope.row["ckslDwLabel"] +
                          ")"
                        : scope.row[item.key]
                    }}
                  </span>
                  <span
                    v-else
                    v-preventReClick
                    style="cursor: pointer"
                    @click="bgcsClick(scope.row)"
                  >{{ scope.row.bgcs }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="200px">
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.zt != '00'"
                    v-preventReClick
                    type="primary"
                    icon="el-icon-document"
                    size="mini"
                    @click="addPupShow('ck', scope.row.id, scope.row)"
                  >查看</el-button>
                  <el-button
                    v-if="scope.row.zt == '00'"
                    v-preventReClick
                    type="primary"
                    icon="el-icon-edit"
                    size="mini"
                    @click="addPupShow('bj', scope.row.id, scope.row)"
                  >编辑</el-button>
                  <el-button
                    v-if="scope.row.zt == '00'"
                    v-preventReClick
                    type="primary"
                    class="deleteButton"
                    icon="el-icon-delete"
                    size="mini"
                    @click="deleteItem(scope.row.id)"
                  >删除</el-button>
                  <el-button
                    v-if="scope.row.zt != '00'"
                    v-preventReClick
                    :type="scope.row.zt == '11' ? 'info' : 'warning'"
                    :disabled="scope.row.zt == '11'"
                    icon="el-icon-edit"
                    size="mini"
                    @click="addPupShow('bg', scope.row.id, scope.row)"
                  >变更</el-button>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>

          <el-pagination
            background
            layout="prev, pager,next,jumper,total,sizes"
            :page-sizes="[10, 20, 30, 40]"
            :total="total"
            :current-page.sync="searchForm.page"
            :page-size="searchForm.size"
            class="el-page"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
    <bgcs
      :bgwindow="bgwindow"
      :bgcs-t-k-name="bgcsTKName"
      @closeBindWarnStandard="handleCloseBindWarnStandard"
    />
    <sy-out-pup
      v-if="pupopShow"
      ref="SyOutPup"
      :cur-id="curId"
      :cur-status="curStatus"
      :djsjshow="djsjshow"
      :bgdisable="bgdisable"
    />
  </div>
</template>
<script>
import SyOutPup from './syOutPup.vue'
import bgcs from '@/components/bgcs'
import {
  syOutList,
  statusOptions,
  deleteSYckListItem,
  getListCkcx,
  exportsyckList
} from '@/assets/js/common.js'
import {dealDataGy} from "@/utils/ppp";
export default {
  components: { SyOutPup, bgcs },
  props: {},
  data() {
    return {
      bgcsTKName: '使用出库',
      bgwindow: false, // 变更次数弹窗
      startTime: {
        disabledDate: (time) => {
          if (this.searchForm.param.endLyrq) {
            return (
              time.getTime() > new Date(this.searchForm.param.endLyrq).getTime()
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },
      endTime: {
        disabledDate: (time) => {
          if (this.searchForm.param.beginLyrq) {
            return (
              time.getTime() > Date.now() ||
              time.getTime() <
                new Date(this.searchForm.param.beginLyrq).getTime()
            )
          } else {
            return time.getTime() > Date.now()
          }
        }
      },

      bgwindow: false,
      // 登记时间隐藏
      djsjshow: false,
      // 变更展示
      bgdisable: true,
      ckmcList: [],
      checkedTableList: [],
      curStatus: null,
      curId: null,
      pupopShow: false,
      statusList: [],
      isDisabled: false,
      searchForm: {
        page: 1,
        size: 10,
        param: {
          hxpMc: '',
          ckId: '',
          beginLyrq: '',
          endLyrq: ''
        }
      },
      table: [
        {
          key: 'ckbh',
          label: '出库编号'
        },
        {
          key: 'hxpMc',
          label: '化学品名称'
        },
        {
          key: 'ckmc',
          label: '仓库名称'
        },
        {
          key: 'cksl',
          label: '出库数量'
        },
        {
          key: 'lyrxm',
          label: '领用人'
        },
        {
          key: 'lyrq',
          label: '领用日期',
          props: 'lyrq'
        },
        {
          key: 'djsj',
          label: '登记时间',
          props: 'djsj'
        },
        {
          key: 'bgcs',
          label: '变更次数'
        },
        {
          key: 'ztLabel',
          label: '状态'
        }
      ],
      tableData: [], // 表格数据
      total: 0 // 总条数
    }
  },
  mounted() {
    // 获取首页仓库下拉
    getListCkcx().then((res) => {
      if (res.status == 200) {
        this.ckmcList = res.data.data
      }
    })
    // 获取首页状态下拉
    statusOptions().then((res) => {
      if (res.status == 200) {
        this.statusList = res.data.data
      }
    })
    // 搜索
    this.getHomeTableList()
  },
  created() {},
  beforeDestroy() {},
  methods: {
    // 点击变更次数
    bgcsClick(curRow) {
      // this.curRowObj = curRow;
      this.$bus.emit('bgcsOpen', curRow, '3')
      this.bgwindow =
        curRow.bgcs > 0 ? (this.bgwindow = !this.bgwindow) : false
    },
    // 关闭窗口
    handleCloseBindWarnStandard() {
      this.bgwindow = false
    },
    // 列表导出
    exportExcel() {
      exportsyckList(this.searchForm)
        .then((res) => {
          if (res.status == 200) {
            this.$message.success('导出成功!')
            const table = '使用出库'
            const a = document.createElement('a')
            const blob = new Blob([res.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
            })
            const objectUrl = URL.createObjectURL(blob)
            a.setAttribute('href', objectUrl)
            a.setAttribute('download', table + '.xlsx')
            a.click()
          }
        })
        .catch((err) => {
          return
        })
    },

    // 使用出库
    addPupShow(status, rowId, row) {
      this.curStatus = status
      if (status == 'ck' || status == 'bg') {
        this.curId = rowId
        setTimeout(() => {
          this.$refs.SyOutPup.initCon(row, 3)
        }, 30)
      }
      if (status == 'bj') {
        this.curId = rowId
        setTimeout(() => {
          this.$refs.SyOutPup.initCon({}, 3)
        }, 30)
      }
      this.pupopShow = true
      if (status == 'add') {
        this.djsjshow = false
        setTimeout(() => {
          this.$refs.SyOutPup.initCon({}, 3)
        }, 30)
      } else {
        this.djsjshow = true
      }

      if (status == 'bg') {
        this.bgdisable = true
      } else {
        this.bgdisable = false
      }
    },
    // 1. 必须选中一条才能新增
    addByCopy() {
      this.djsjshow = false
      if (this.checkedTableList.length == 0) {
        this.$message.warning('请先选中一条数据!')
        return
      } else if (this.checkedTableList.length > 1) {
        this.$message.warning('只能选中一条数据!')
        return
      } else {
        // 复制新增
        this.curStatus = 'copyAdd'
        this.curId = this.checkedTableList[0].id
        this.pupopShow = true
        this.djsjshow = false
        this.bgdisable = false
        this.checkedTableList = []
        return
      }
    },
    // 选中首页所有数据
    homeSelectAll(selection) {
      this.checkedTableList = selection
    },
    // 多选框设置为单选功能
    handleSelectionChange(val) {
      this.checkedTableList = val
      if (val.length > 1) {
        this.$refs.cktable.clearSelection()
        this.$refs.cktable.toggleRowSelection(val.pop())
      }
    },
    // pageSize改变
    handleSizeChange(sizeVal) {
      this.searchForm.size = sizeVal
      this.getHomeTableList()
    },
    // 当前页面变化
    handleCurrentChange(currentPageVal) {
      this.searchForm.page = currentPageVal
      this.getHomeTableList()
    },
    reset() {
      this.searchForm = {
        page: 1,
        size: 10,
        param: {
          hxpMc: '',
          ckId: '',
          beginLyrq: '',
          endLyrq: '',
          zt: ''
        }
      }
      this.getHomeTableList()
    },
    // 删除
    deleteItem(rowId) {
      this.$confirm('确认选择当前库存信息吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then((res) => {
          deleteSYckListItem(rowId).then((res) => {
            this.getHomeTableList()
            this.$message.success('删除成功!')
          })
        })
        .catch((err) => {
          return
        })
    },
    // 使用出库
    async getHomeTableList() {
      this.searchForm.param.vdata = await dealDataGy()
      syOutList(this.searchForm).then((res) => {
        if (res.status == 200) {
          this.tableData = res.data.data.rows
          this.total = res.data.data.total
        }
      })
    },

    cellStyle({ row, column, rowIndex, columnIndex }) {
      let cellStyle
      if (columnIndex == 9) {
        switch (row.zt) {
          case '01':
            cellStyle = 'color:#6FC89A;font-weight:bold '
            break
          case '11':
            cellStyle = 'color:#43A5E2;font-weight:bold '
            break
          case '00':
            cellStyle = 'color:#000;font-weight:bold '
            break
          default:
            cellStyle = ''
            break
        }
        return cellStyle
      }
    }
  }
}
</script>
<style scoped lang="less">
.el-table--border {
  z-index: 0;
}
.resetbutton {
  width: 90px;
  height: 39px;
  border-radius: 20px;
}
.shiyong_out {
  // height: 100%;
  // width: 90%;
  // background-color: white;
  // margin: auto;
  .headerSearch {
    max-width: 1518px;
    width: 95%;
    margin: auto;
    margin-bottom: 11px;
    margin-top: 30px;
    background-color: white;
    padding: 30px 0 20px 0;
    // border: 1px solid red;
    display: flex;
    align-items: center;
    box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    .el-form-item {
      margin-bottom: 10px;
      margin-right: 30px;
      &:last-child {
        width: 90px;
        height: 39px;
        /deep/ .el-button {
          width: 90px !important;
          height: 39px;
          border-radius: 3px;
        }
      }
    }
  }
  .sousuo {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    .sousuoButton {
      width: 90px;
      height: 39px;
      background: #4170ff;
      border-color: #4170ff;
    }
    .chongzhiButton {
      width: 90px;
      height: 39px;
    }
  }
  .tablemes {
    margin: auto;
    width: 90%;
    max-width: 1375px;
    // margin-top: 21px;
    // margin-bottom: 57px;
    .el-pagination__total {
      margin-left: 8px;
    }
    .el-pagination {
      padding: 10px 0;

      border: 1px solid #ebeef5;
      border-top: 0;
    }
    // .addButton {
    //   color: #fff;
    //   background: #4170ff;
    //   border-radius: 3px;
    //   border-color: #4170ff;
    // }
    .deleteButton {
      background: #ff5721 !important;
      border-color: #ff5721 !important;
    }
    .el-button--warning {
      color: #fff;
      background: #feb800;
      border-radius: 3px;
      border-color: #feb800;
    }
    .el-button--primary {
      color: #fff;
      background: #4170ff;
      border-radius: 3px;
      border-color: #4170ff;
    }
    .el-pager {
      .number {
        background: #4170ff;
        border-color: #4170ff;
      }
    }
  }
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
/deep/.el-table__header-wrapper .el-checkbox {
  //找到表头那一行，然后把里面的复选框隐藏掉
  display: none;
}
</style>
